import { useState, useEffect, useCallback, useRef } from 'react';
import { Category } from '../types/exporter';
import { exporterService } from '../../../../api/cansense/exporterApi';

interface UseCategoriesReturn {
  categories: Category[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useCategories = (): UseCategoriesReturn => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const mountedRef = useRef(true);

  const fetchCategories = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await exporterService.getCategories();
      if (mountedRef.current) {
        setCategories(data);
      }
    } catch (err) {
      if (mountedRef.current) {
        const errorMessage = err instanceof Error ? err.message : 'Failed to fetch categories';
        setError(errorMessage);
        console.error('Failed to fetch categories:', err);
      }
    } finally {
      if (mountedRef.current) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    fetchCategories();
    return () => { mountedRef.current = false; };
  }, [fetchCategories]);

  return { categories, loading, error, refetch: fetchCategories };
};
